import  React, { ReactElement } from 'react';
import styled from 'styled-components';
import {themes} from './ui/theme';
import { Header } from './ui/header';
import { Background } from './ui/background';
import { Body } from './ui/body';


const StyledApp = styled.div`
  font-family: 'Montserrat', sans-serif;
  text-decoration: none;
  font-weight: 600;
`;

const StyledFooter = styled.div`
  background: ${themes.background.main};
  height: 5vh;
`;

const App = (): ReactElement => {
  return (
    <StyledApp>
      <Header/>
      <Background src='"./TP6-bnw-min.png"'/>
      <Body/>
      <Background src='"./TP7-bnw-min.jpg"'/>
      <StyledFooter>
      </StyledFooter>
    </StyledApp>
  );
}

export {App};
